import { css } from "lit";

export const styles = css`
  .form-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .form-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .form-row > * {
    flex: 1;
  }

  .date-time-section {
    display: flex;
    flex-direction: column;
  }

  .section-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .section-label {
    font-weight: var(--sds-typography-weight-medium);
    color: var(--sds-color-text-default-default);
  }

  .section-subtitle {
    color: var(--sds-color-text-default-tertiary);

    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
  }

  .toggle-field {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .linked-links-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-size-radius-400);
    max-height: 200px;
    overflow-y: auto;
  }

  .loading-links,
  .no-links {
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-tertiary);
    padding: 8px;
    text-align: center;
  }

  .links-checklist {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .link-checkbox-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    border-radius: var(--sds-size-radius-400);
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .link-checkbox-item:hover {
    background: var(--sds-color-background-default-tertiary);
  }

  .link-checkbox-item input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--sds-color-background-brand-default);
  }

  .link-label {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .discount-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-00) var(--sds-typography-family-body);
    color: var(--sds-color-text-success-default);
    background: var(--sds-color-background-success-subtle);
    border-radius: var(--sds-size-radius-200);
    margin-left: auto;
  }
`;
